export enum JobStatus {
  PENDING = "Pending",
  COLLECTION = "Collected",
  IN_PROGRESS = "In Progress",
  COMPLETE = "Complete",
}

export enum InternalJobStatus {
  PENDING = "Pending",
  COMPLETE = "Complete",
}